<div class="container">

    <div class="row" style="margin: 30px;">
        <div class="col">

            <h4 style="text-align: center; margin-top: 20px;">Select a dashboard:</h4>      
            <div style="text-align: center;"><img *ngIf="loadingDashboards" src="{{ this.authService.LOADING_IMAGE_URL }}"></div>

            <div class="container d-flex justify-content-center" style="margin-top: 30px;">
                <div class="row text-center">
                  <div class="col-12 col-md-4 mb-4" *ngFor="let dashboard of dashboards">
                    <div style="margin: 30px auto 0 auto; border: 1px solid lightgray; border-radius: 5px; max-width: 300px;">
                        <a routerLink="/dashboards/{{ dashboard.id }}">
                            <img [src]="dashboard.logo ?? '/assets/images/pix.gif'" [alt]="dashboard.name" [title]="dashboard.name" style="width: 160px; height: 80px;">
                        </a>
                    </div>
                  </div>
                </div>
            </div>

        </div>
    </div>

</div>